export default "__VITE_ASSET__8ef31c96__"